import { mockedProducts } from "./products";
import { ISearchResults } from "../components/Navigational/Search/SearchResults/SearchResults.interface";

export const mockServerResponse: ISearchResults = {
  results: [
    {
      ...mockedProducts[0],
      itemName: "Men's",
      count: 112,
    },
    { ...mockedProducts[1], itemName: "Nike", count: 92 },
    {
      ...mockedProducts[2],
      itemName: "Men's Trail",
      count: 62,
    },
    {
      ...mockedProducts[3],
      itemName: "Nike Zoom Pegasus 37 Running Shoes",
      count: 23,
    },
    {
      ...mockedProducts[4],
      itemName: "Men's Hiking",
      brand: "adidas",
      count: 15,
    },
  ],
  recent: [
    { ...mockedProducts[0], itemName: "Running" },
    { ...mockedProducts[1], itemName: "Jacket" },
    { ...mockedProducts[2], itemName: "Home Fitness" },
  ],
  popular: [
    { ...mockedProducts[0], itemName: "Nike Air Max" },
    { ...mockedProducts[1], itemName: "Adidas", brand: "adidas" },
    { ...mockedProducts[2], itemName: "Fitness" },
    { ...mockedProducts[3], itemName: "Training Gears" },
    { ...mockedProducts[4], itemName: "Ajax" },
  ],
  highLight: [
    {
      ...mockedProducts[0],
      itemName: "Running Shoes",
      count: 192,
      selectable: true,
    },
  ],
  detailResults: mockedProducts,
  relevantResults: mockedProducts,
  category: "Men's Shoes",
};

export const mockEmptyServerResponse: ISearchResults = {
  recent: [
    { ...mockedProducts[0], itemName: "Running" },
    { ...mockedProducts[1], itemName: "Jacket" },
    { ...mockedProducts[2], itemName: "Home Fitness" },
  ],
  popular: [
    { ...mockedProducts[0], itemName: "Nike Air Max" },
    { ...mockedProducts[1], itemName: "Adidas" },
    { ...mockedProducts[2], itemName: "Fitness" },
    { ...mockedProducts[3], itemName: "Training Gears" },
    { ...mockedProducts[4], itemName: "Ajax" },
  ],
  category: "Men's Shoes",
};

export const mockCities = [
  {
    id: "1",
    label: "London",
  },
  {
    id: "2",
    label: "Berlin",
  },
  {
    id: "3",
    label: "Istanbul",
  },
  {
    id: "4",
    label: "Dresden",
  },
  {
    id: "5",
    label: "Tokyo",
  },
  {
    id: "6",
    label: "Paris",
  },
  {
    id: "7",
    label: "Milan",
  },
  {
    id: "8",
    label: "New York",
  },
  {
    id: "9",
    label: "Toronto",
  },
  {
    id: "10",
    label: "Chicago",
  },
  {
    id: "11",
    label: "Vienna",
  },
  {
    id: "12",
    label: "Jakarta",
  },
  {
    id: "13",
    label: "Delhi",
  },
  {
    id: "14",
    label: "Manila",
  },
  {
    id: "15",
    label: "Shanghai",
  },
  {
    id: "16",
    label: "Karachi",
  },
  {
    id: "17",
    label: "Beijing",
  },
  {
    id: "18",
    label: "Sao Paulo",
  },
  {
    id: "19",
    label: "Mexico City",
  },
  {
    id: "20",
    label: "Mumbai",
  },
];
